import { render } from "./submenuAccount.vue?vue&type=template&id=286e62c8"
import script from "./submenuAccount.vue?vue&type=script&lang=js"
export * from "./submenuAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__